"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("./react");

var isClient = typeof window === 'object';

var useWindowSize = function useWindowSize() {
  var initialWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Infinity;
  var initialHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;

  var _react_1$useState = react_1.useState({
    width: isClient ? window.innerWidth : initialWidth,
    height: isClient ? window.innerHeight : initialHeight
  }),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      state = _react_1$useState2[0],
      setState = _react_1$useState2[1];

  react_1.useEffect(function () {
    var handler = function handler() {
      setState({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handler);
    return function () {
      return window.removeEventListener('resize', handler);
    };
  }, [1]);
  return state;
};

exports.default = useWindowSize;